// extracted by mini-css-extract-plugin
export default {"limits":"GameLiveLimits__limits--3oE"};